import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginThunk } from '../../store';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector(s => s.auth);
  const [form, setForm] = useState({ phone: '', password: '' });
  const [focused, setFocused] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    const res = await dispatch(loginThunk(form));
    if (res.meta.requestStatus === 'fulfilled') {
      toast.success('Xoş gəldiniz!');
      navigate('/');
    } else {
      toast.error(error || 'Giriş uğursuz oldu');
    }
  };

  const inputStyle = (name) => ({
    ...S.input,
    borderColor: focused === name ? '#00c896' : '#2a2a3a',
    background: focused === name ? '#17171f' : '#121218',
  });

  return (
    <div style={S.wrap}>
      <div style={S.glow} />
      <div style={S.orbs} />
      <div style={S.card}>
        <div style={S.logo}>
          <img src="/assets/logo-mark.png" alt="BG Sync" style={S.logoImg} />
          <div style={S.brandName}>BAKU GATE</div>
          <div style={S.logoSub}>Admin Panel</div>
        </div>

        <form onSubmit={handleSubmit} style={S.form}>
          <div style={S.field}>
            <label style={S.label}>Telefon nömrəsi</label>
            <input
              style={inputStyle('phone')}
              type="text"
              placeholder="+994501234567"
              value={form.phone}
              onChange={e => setForm({ ...form, phone: e.target.value })}
              onFocus={() => setFocused('phone')}
              onBlur={() => setFocused('')}
              required
            />
          </div>
          <div style={S.field}>
            <label style={S.label}>Şifrə</label>
            <input
              style={inputStyle('password')}
              type="password"
              placeholder="••••••••"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              onFocus={() => setFocused('password')}
              onBlur={() => setFocused('')}
              required
            />
          </div>
          <button
            style={{ ...S.btn, opacity: loading ? 0.6 : 1 }}
            type="submit"
            disabled={loading}
          >
            {loading ? 'Giriş edilir...' : 'Daxil ol →'}
          </button>
        </form>

        <div style={S.footer}>
          <span style={S.footerDot} />
          Baku Gate — Azerbaijan Super App &nbsp;·&nbsp; <span style={{ color: '#00c896', fontWeight: 700 }}>by.Elvin</span>
        </div>
      </div>
    </div>
  );
}

const S = {
  wrap: {
    minHeight: '100vh',
    background: '#0d0d12',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  glow: {
    position: 'absolute',
    width: 700,
    height: 700,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(0,200,150,0.08) 0%, transparent 68%)',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    pointerEvents: 'none',
  },
  orbs: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: `
      radial-gradient(ellipse 280px 160px at 15% 20%, rgba(0,200,150,0.04) 0%, transparent 100%),
      radial-gradient(ellipse 220px 140px at 85% 80%, rgba(0,229,168,0.04) 0%, transparent 100%)
    `,
    pointerEvents: 'none',
  },
  card: {
    background: '#1d1d27',
    border: '1px solid #2a2a3a',
    borderRadius: 20,
    padding: '48px 40px',
    width: 400,
    position: 'relative',
    boxShadow: '0 32px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(0,200,150,0.06)',
  },
  logo: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, marginBottom: 36 },
  logoImg: { width: 84, height: 84, display: 'block' },
  brandName: {
    fontWeight: 800, fontSize: 20, color: '#dde3ef',
    letterSpacing: '0.12em', marginTop: 6,
  },
  logoSub: {
    fontFamily: "'Inter',sans-serif",
    fontSize: 10,
    color: '#3f4756',
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    marginTop: 2,
  },
  form: { display: 'flex', flexDirection: 'column', gap: 20 },
  field: { display: 'flex', flexDirection: 'column', gap: 8 },
  label: { fontSize: 12, color: '#7a8899', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase' },
  input: {
    background: '#121218',
    border: '1px solid #2a2a3a',
    borderRadius: 10,
    padding: '13px 16px',
    color: '#dde3ef',
    fontSize: 15,
    outline: 'none',
    transition: 'border-color 0.2s, background 0.2s',
    width: '100%',
    boxSizing: 'border-box',
  },
  btn: {
    background: 'linear-gradient(135deg, #00c896, #00e5a8)',
    color: '#0d0d12',
    border: 'none',
    borderRadius: 10,
    padding: '14px',
    fontSize: 15,
    fontWeight: 800,
    cursor: 'pointer',
    marginTop: 8,
    transition: 'opacity 0.2s',
    letterSpacing: '0.03em',
  },
  footer: {
    marginTop: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    fontSize: 11,
    color: '#3f4756',
    letterSpacing: '0.05em',
  },
  footerDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#00c896',
    display: 'inline-block',
    animation: 'pulse 2s infinite',
  },
};
